import axios from 'axios'

const instance = axios.create({
    baseURL: 'bada/cityAdmin/admin',
    // baseURL: 'http://192.168.1.254:9091/api/cityAdmin/admin',
    timeout: 20000,
    headers: { 'X-Custom-Header': 'MX', project_token: 18111501 },
    withCredentials: true,
})

// 请求拦截
instance.interceptors.request.use(
    config => {
        config.headers.user_token = sessionStorage.getItem('user_token')
        return config
    },
    error => {
        return Promise.reject(error)
    }
)

// 响应拦截
instance.interceptors.response.use(
    response => {
        // 处理响应数据
        console.log(response, 'response')
        if (response.status == 200) {

            return Promise.resolve(response.data)
        } else if (response.status === 401) {


            return Promise.reject(response.data)
        } else if (response.status == 404) {


            return Promise.reject(response.data)
        }
        else if (response.status == 500) {


            return Promise.reject(response.data)
        } else {
            // debugger

            return Promise.reject(response.data)
        }
    }, err => {
        return Promise.reject(err)
    }
)


export default instance




// WEBPACK FOOTER //
// ./src/api/axios.js